import React, { useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SnackbarNotification = ({ open, handleClose, message, severity }) => {
  useEffect(() => {
    let timer;
    if (open) {
      timer = setTimeout(() => handleClose(), 6000); // Hide snackbar after 3 seconds
    }
    return () => clearTimeout(timer); // Clear timeout if snackbar closes before 3 seconds
  }, [open, handleClose]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Position snackbar at the top center
    >
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarNotification;
